import { Component, Prop, Vue } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import vSelect from 'vue-select'
import fetch from '@/helpers/fetch'
import { Auditoria } from '@/types/auditoria'
import TypeableDatePortal from '@/components/edit/TypeableDatePortal/index.vue'

library.add(faChevronDown)

@Component({
	components: { TypeableDatePortal, vSelect },
})
export default class AuditLog extends Vue {
	@Prop({ required: true }) auditoria!: Auditoria
	@Prop({ required: true }) collapseIndex!: number | string

	form: any = {}
	saving = false
	password = ''

	users: any[] = []
	groups: any[] = []
	loadingOptions = false

	options = {
		source: [
			{ value: 'carta', text: 'Carta' },
			{ value: 'relatório', text: 'Relatório' },
		],
		response_type: [
			{ value: 'email', text: 'E-mail' },
			{ value: 'portal-terceiro', text: 'Portal terceiro' },
			{ value: 'correio', text: 'Correio' },
		],
		status: [
			{ value: 'Pendente', text: 'Pendente' },
			{ value: 'Arquivado', text: 'Arquivado' },
		],
	}

	get collapseId(): string {
		return `audit-log-${this.collapseIndex}`
	}

	get statusVariant(): string {
		switch (this.auditoria.status) {
			case 'Pendente':
				return 'warning'
			default:
				return 'secondary'
		}
	}

	async created() {
		this.syncForm()

		this.loadingOptions = true
		try {
			const [usersRes, groupsRes] = await Promise.all([
				fetch.get('/api/users?name=@locatelliadv.com.br'),
				fetch.get('/api/groups'),
			])
			this.users = usersRes.data || []
			this.groups = groupsRes.data || []
		} finally {
			this.loadingOptions = false
		}
	}

	syncForm() {
		const a = this.auditoria
		this.form = {
			id: a.id,
			group_id: a.group?.id ?? null,
			responsible_id: a.responsible?.id ?? null,
			source: a.source,
			response_type: a.response_type,
			status: a.status,
			request_date: a.request_date,
			base_date: a.base_date,
			response_deadline: a.response_deadline,
			sent_at: a.sent_at || '',
			obs: a.obs,
		}
	}

	onStatusChange(val: string) {
		if (val === 'Arquivado' && !this.form.sent_at) {
			const today = new Date()
			const y = today.getFullYear()
			const m = String(today.getMonth() + 1).padStart(2, '0')
			const d = String(today.getDate()).padStart(2, '0')
			this.form.sent_at = `${y}-${m}-${d}`
		}
	}

	async save() {
		this.saving = true
		try {
			const payload = {
				group_id: this.form.group_id,
				responsible_id: this.form.responsible_id || null,
				source: this.form.source,
				response_type: this.form.response_type,
				status: this.form.status,
				request_date: this.form.request_date,
				base_date: this.form.base_date,
				response_deadline: this.form.response_deadline,
				sent_at: this.form.sent_at || null,
				obs: this.form.obs || null,
				password: this.password,
			}
			const res = await fetch.put('/api/audits/' + this.form.id, payload)
			if (res.ok) {
				this.$bvToast.toast('Auditoria salva com sucesso.', {
					title: 'Salvo',
					variant: 'success',
					noCloseButton: true,
					autoHideDelay: 3000,
					toaster: 'b-toaster-top-center',
				})
				this.$emit('saved', { ...this.auditoria, ...payload })
				if (payload.status !== 'Arquivado') {
					this.$root.$emit('bv::toggle::collapse', this.collapseId)
				}
			} else {
				this.$bvToast.toast(res.msg || 'Erro ao salvar.', {
					title: 'Erro',
					variant: 'danger',
					noCloseButton: false,
					autoHideDelay: 3000,
					toaster: 'b-toaster-top-center',
				})
			}
		} finally {
			this.saving = false
		}
	}

	formatDate(dateStr: string | null): string {
		if (!dateStr) return '—'
		const [year, month, day] = dateStr.split('-')
		if (!year || !month || !day) return dateStr
		return `${day}/${month}/${year}`
	}
}
